import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import { enregistreAdresseFE } from '../../App_Code/API';

const ModalAdresseFE = ({ isOpen, onClose, data, onRefresh, codeIndRedux, siretParDefaut }) => {
    const [form, setForm] = useState({
        NumAuto: 0,
        FormatFE: 'SUFFIX',
        SIRET: '',
        Suffixe: '',
        SQLDateDebMandat: '',
        SQLDateFinMandat: '',
        EnEmission: "False"
    });

    const formatToInputDate = (dateValue) => {
        if (!dateValue || dateValue === "" || dateValue.includes("0001")) return "";
        if (typeof dateValue === 'string' && dateValue.includes('/')) {
            const [j, m, a] = dateValue.split('/');
            return a + "-" + m + "-" + j;
        }
        return dateValue.split('T')[0];
    };

    useEffect(() => {
        if (isOpen) {
            const modeEmission = data && data.ReceptionEmission === 1 ? "True" : "False";
            if (data) {
                setForm({
                    ...data,
                    EnEmission: modeEmission,
                    SQLDateDebMandat: formatToInputDate(data.SQLDateDebMandat),
                    SQLDateFinMandat: formatToInputDate(data.SQLDateFinMandat)
                });
            } else {
                setForm({
                    NumAuto: 0,
                    FormatFE: 'SUFFIX',
                    SIRET: siretParDefaut || '', // On charge le SIRET complet par défaut
                    Suffixe: '',
                    EnEmission: modeEmission,
                    SQLDateDebMandat: new Date().toISOString().split('T')[0],
                    SQLDateFinMandat: ''
                });
            }
        }
    }, [isOpen, data, siretParDefaut]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        // Logique GenAdresseFE() basée sur le SIRET complet saisi dans la 1ère case
        let resGen = form.SIRET; 
        
        // Si format Suffixe, on concatène (ex: SIRET_Suffixe)
        if (form.FormatFE === 'SUFFIX') {
            resGen += "_" + form.Suffixe;
        }

        const finalAdresse = resGen.length > 125 ? resGen.substring(0, 125) : resGen;

        const currentCodeInd = (data && data.CodeInd) ? data.CodeInd : codeIndRedux;

        const payload = { 
            ...form, 
            CodeInd: currentCodeInd, 
            AdresseFE: finalAdresse,
            ActifOk: 1,
            ReceptionEmission: form.EnEmission === "True" ? 1 : 0 
        };

      try {
            const res = await enregistreAdresseFE(payload);

            // Cas Succès
            if (res && res.status === 200) {
                swal.fire("Succès", "L'adresse a été enregistrée.", "success");
                onRefresh();
                onClose();
            } 
            // Cas Erreur métier renvoyée par l'API (ex: SIRET invalide)
            else {
                // On essaie de récupérer le message d'erreur envoyé par le Controller VB
                const errorMsg = (res && res.data && res.data.message) 
                    ? res.data.message 
                    : "Une erreur est survenue lors de l'enregistrement.";
                
                swal.fire("Erreur", errorMsg, "error");
            }
        } catch (error) {
            // Cas Erreur critique (Crash API, Coupure réseau, etc.)
            console.error("Erreur handleSave:", error);
            swal.fire(
                "Erreur technique", 
                "Impossible de contacter le serveur. Veuillez réessayer plus tard.", 
                "error"
            );
        }
    };

    if (!isOpen) return null;

    const isSuffixVisible = (form.FormatFE === 'SUFFIX');
    const getTitre = () => {
        const prefix = form.NumAuto > 0 ? "Modification" : "Ajout";
        return prefix + " d'une adresse de facturation électronique";
    };

    return (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050 }}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content shadow-lg border-0">
                    <header className="modal-header d-block">
                        <h2 className="modal-title fs-5 fw-bold">
                            {getTitre()} 
                            <span className="text-muted fw-light"><i>{form.EnEmission === "True" ? " en émission" : " en réception"}</i></span>
                        </h2>
                    </header>
                    
                    <div className="modal-body p-4">
                        <div className="saisie">
                            {/* LIGNE FORMAT */}
                            <div className="row mb-3 align-items-center">
                                <div className="col-4 lib text-end">Format</div>
                                <div className="col-7">
                                    <select className="form-select" name="FormatFE" value={form.FormatFE} onChange={handleChange}>
                                        <option value="SIREN">SIREN</option>
                                        <option value="SUFFIX">SIREN / Suffixe</option>
                                    </select>
                                </div>
                            </div>

                            {/* LIGNE VALEURS (SIRET / Suffixe) */}
                            <div className="row mb-3 align-items-center">
                                <div className="col-4 lib text-end">SIRET / Suffixe</div>
                                
                                {/* 1ère case : Toujours le SIRET (en lecture seule car vient de la fiche) */}
                                <div className="col-3">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        style={{backgroundColor: 'LightGray'}} 
                                        value={form.SIRET} 
                                        readOnly 
                                    />
                                </div>

                                {/* Séparateur et 2ème case (Suffixe) */}
                                {isSuffixVisible && (
                                    <React.Fragment>
                                        <div className="col-3">
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                name="Suffixe" 
                                                placeholder="Suffixe"
                                                value={form.Suffixe} 
                                                onChange={handleChange} 
                                                maxLength="20" 
                                            />
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>

                            {/* LIGNE DATES */}
                            <div className="row mb-3 align-items-center">
                                <div className="col-4 lib text-end">Date début de Mandat</div>
                                <div className="col-3 text-center">
                                    <input type="date" className="form-control" name="SQLDateDebMandat" value={form.SQLDateDebMandat} onChange={handleChange} />
                                </div>
                                <div className="col-2 lib text-end">Date de fin</div>
                                <div className="col-3 text-center">
                                    <input type="date" className="form-control" name="SQLDateFinMandat" value={form.SQLDateFinMandat} onChange={handleChange} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer-fixe p-3 bg-light text-center border-top">
                        <button className="btn btn-primary px-4 me-2 shadow-sm" onClick={handleSave}>Enregistrer</button>
                        <button className="btn btn-secondary px-4 shadow-sm" onClick={onClose}>Fermer</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    var ind = (state.ProStore && state.ProStore.Pro && state.ProStore.Pro.Ind) ? state.ProStore.Pro.Ind : {};
    return {
        codeIndRedux: ind.Code || '',
        siretParDefaut: ind.SIRET || ''
    };
}

export default connect(mapStateToProps)(ModalAdresseFE);


// WEBPACK FOOTER //
// ./src/components/MesInfos/ModalAdresseFE.js